module.exports = __webpack_public_path__ + "static/media/Nicoleño_icon.4e049775.png";